import { api } from './api.service';

export type ICreateConversionDTO = {
  conversionIdentifier: string;
  email: string;
  name: string;
  tags?: string[];
};
export const marketing = api.injectEndpoints({
  endpoints: build => ({
    createConversion: build.mutation<ICreateConversionDTO, any>({
      query: data => ({
        url: `/marketing/createConversion`,
        method: 'POST',
        body: data,
        headers: {}
      })
    })
  })
});

export const { useCreateConversionMutation } = marketing;
